(function () {
  const FREE_GIFT_VARIANT_ID = 53013709652284;
  let syncing = false;

  async function syncFreeGift() {
    if (syncing) return;
    syncing = true;
    try {
      const cart = await fetch('/cart.js').then((r) => r.json());
      const hasRealItems = cart.items.some((i) => i.variant_id != FREE_GIFT_VARIANT_ID);
      const hasGift = cart.items.some((i) => i.variant_id == FREE_GIFT_VARIANT_ID);

      if (hasRealItems && !hasGift) {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: FREE_GIFT_VARIANT_ID, quantity: 1 }] }),
        });
        const updatedCart = await fetch('/cart.js').then((r) => r.json());
        if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'free-gift', cartData: updatedCart });
        }
      } else if (!hasRealItems && hasGift) {
        const updates = {};
        cart.items.forEach((item, idx) => {
          if (item.variant_id == FREE_GIFT_VARIANT_ID) updates[idx + 1] = 0;
        });
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates }),
        });
        const updatedCart = await fetch('/cart.js').then((r) => r.json());
        if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'free-gift', cartData: updatedCart });
        }
      }
    } catch (e) {
      console.error('[FreeGift]', e);
    } finally {
      syncing = false;
    }
  }

  // Add the syringe to cart silently, returns a promise
  async function addFreeGiftSilent() {
    try {
      const cart = await fetch('/cart.js').then((r) => r.json());
      const hasGift = cart.items.some((i) => i.variant_id == FREE_GIFT_VARIANT_ID);
      if (!hasGift) {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: FREE_GIFT_VARIANT_ID, quantity: 1 }] }),
        });
      }
    } catch (e) {
      console.error('[FreeGift]', e);
    }
  }

  window.addEventListener('load', function () {

    // ── Add to Cart button ──────────────────────────────────────────
    document.addEventListener('click', function (e) {
      const btn = e.target.closest('[name="add"], .product-form__submit');
      if (btn) {
        setTimeout(syncFreeGift, 300);
      }
    });

    // ── PubSub (fires after cart update) ────────────────────────────
    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && event.source === 'free-gift') return;
        setTimeout(syncFreeGift, 300);
      });
    }

    // ── Cart drawer observer ─────────────────────────────────────────
    var drawer = document.querySelector('cart-drawer') || document.querySelector('#CartDrawer');
    if (drawer) {
      new MutationObserver(function () {
        if (!syncing) setTimeout(syncFreeGift, 300);
      }).observe(drawer, { childList: true, subtree: true });
    }

    // ── Buy Now / Dynamic checkout buttons ──────────────────────────
    // These bypass the cart, so we intercept, add the syringe first,
    // then redirect to checkout manually.
    document.addEventListener('click', function (e) {
      const buyNowBtn = e.target.closest(
        '.shopify-payment-button__button, [data-testid="Checkout-button"], .product-form__checkout'
      );
      if (!buyNowBtn) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      // First add the main product via its form, then add syringe, then checkout
      var form = document.querySelector('form[action*="/cart/add"]') || document.getElementById('product-form');
      var addPromise = Promise.resolve();

      if (form) {
        var formData = new FormData(form);
        addPromise = fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
        }).catch(function () {});
      }

      addPromise
        .then(function () { return addFreeGiftSilent(); })
        .then(function () {
          window.location.href = '/checkout';
        });
    }, true); // useCapture to intercept before Shopify's own handler

    // ── Run once on load ─────────────────────────────────────────────
    syncFreeGift();
  });
})();
